import { render } from "./loading-overlay.vue?vue&type=template&id=6cbf09bb"
const script = {}

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__